import Link from 'next/link';
import Image from 'next/image';
import { Trans, useTranslation } from 'next-i18next';
import { useTheme } from '@forma/forma-ui-theme';
import { Modal } from '@forma/forma-ui-kit';
import ClientWrap from '@/components/ClientWrap';
import analytics from '@/helpers/analytics';
import { useRequestCall } from '../RequestCall';
import RequestRegisterModalForm from './RequestRegisterModalForm';
import { useTrialDaysText } from '@/hooks/useTrialDays';

import styles from './request-register-modal.module.css';

const RequestRegisterModal = ({ open, onClose }) => {
  const { t } = useTranslation();
  const trialDays = useTrialDaysText();
  const { lang, viewport } = useTheme();
  const isPhoneOrTablet = ['phone', 'tabletS'].includes(viewport);
  const isPhone = viewport === 'phone';

  const { onSubmit, isSuccess, isError, isLoading, reset } = useRequestCall({ lang });

  const handleSubmit = (values) => {
    onSubmit(values).then(success => {
      if (success) {
        analytics.sendRequestForm();
      }
    });
  };

  const closeModal = () => {
    reset();
    onClose();
  };

  const title = <div>Получите расширенный пробный <br /> доступ на {trialDays} бесплатно</div>;

  return (
    <ClientWrap>
      <Modal
        open={open}
        onClose={closeModal}
        width="100%"
        maxWidth="1092px"
        title={isPhone && title}
      >
        <div className={styles.container}>
          <div className={styles.content}>
            <input type="hidden" autoFocus />
            {!isPhone && (
              <div className={styles.title}>{title}</div>
            )}
            {!(isError || isSuccess) && (
              <div className={styles.subtitle}>
                Заполните поля для получения доступа {isPhone ? <br /> : ' '} и переноса до 5-ти ваших документов {isPhone ? <br /> : ' '} на сервис бесплатно.
              </div>
            )}
            {isPhoneOrTablet && (
              <Image className={styles.image} src="/images/browser-filling.svg" width={540} height={272} alt="" />
            )}
            <RequestRegisterModalForm
              onSubmit={handleSubmit}
              isSendSuccess={isSuccess}
              isSendError={isError}
              isSendLoading={isLoading}
              buttonText={t('start_free')}
              noticeText={
                <Trans
                  i18nKey="user_agreement_form_notice"
                  components={{
                    privacy: <Link href="/privacy" target="_blank" />,
                    license: <Link href="/license" target="_blank" />,
                    button: t('start_free'),
                  }}
                />
              }
            />
          </div>
          {!isPhoneOrTablet && (
            <Image className={styles.image} src="/images/browser-filling.svg" width={540} height={272} alt="" />
          )}
        </div>
      </Modal>
    </ClientWrap>
  );
};

export default RequestRegisterModal;
